class ActionProvider {
  constructor(createChatBotMessage, setStateFunc) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
  }

  greet = () => {
    const message = this.createChatBotMessage("Hello, how can i help you.");
    this.addMessageToState(message);
  };

  mailFunc = () => {
    const message = this.createChatBotMessage(
      "Here's the email to contact with money manager team admin@moneymanagerindia.in"
    );
    this.addMessageToState(message);
  };

  mobileFunc = () => {
    const message = this.createChatBotMessage(
      "Here's the mobile no to contact our money manager team +91 8888830536"
    );
    this.addMessageToState(message);
  };

  handleSupportOption = () => {
    const message = this.createChatBotMessage(
      "Our team is always ready to resolve your problems.",
      {
        widget: "support",
      }
    );

    this.addMessageToState(message);
  };

  handlePricingOption = () => {
    const message = this.createChatBotMessage(
      "Here are the details of pricing of the software.",
      {
        widget: "pricing",
      }
    );
    this.addMessageToState(message);
  };

  handleContactOption = () => {
    const message = this.createChatBotMessage(
      "Here's the process to contact to our team.",
      {
        widget: "contact",
      }
    );
    this.addMessageToState(message);
  };

  addMessageToState = (message) => {
    this.setState((prevState) => ({
      ...prevState,
      messages: [...prevState.messages, message],
    }));
  };
}

export default ActionProvider;
